<script>
import { GlFormGroup, GlFormInput } from '@gitlab/ui';
import { ValidationProvider } from 'vee-validate';

const MULTIPLE_NAMES_ASSOCIATED_FEEDBACK_TEXT = 'Email must be associated with only one name.';

export default {
  name: 'NameField',
  components: {
    GlFormGroup,
    GlFormInput,
    ValidationProvider,
  },
  props: {
    label: {
      type: String,
      required: true,
    },
    testId: {
      type: String,
      required: true,
    },
    groupClass: {
      type: [String, Object, Array],
      required: false,
      default: '',
    },
    alternativeNames: {
      type: Array,
      required: false,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emits: ['input', 'blur'],
  mounted() {
    const validationError = {
      errors: [MULTIPLE_NAMES_ASSOCIATED_FEEDBACK_TEXT],
      valid: false,
      failedRules: {},
    };
    if (this.alternativeNames.length) {
      this.$refs.nameProvider.applyResult(validationError);
    }
  },
  methods: {
    getNameValidationState(validationContext) {
      const { dirty, validated, passed = null } = validationContext;
      return dirty || validated ? passed : null;
    },
  },
};
</script>

<template>
  <validation-provider
    ref="nameProvider"
    #default="validationContext"
    :name="label"
    rules="required|noEmoji"
    slim
  >
    <gl-form-group
      :class="groupClass"
      :data-testid="testId"
      :label="label"
      :label-for="$attrs.id"
      :invalid-feedback="validationContext.errors[0]"
      :state="getNameValidationState(validationContext)"
    >
      <gl-form-input
        :id="$attrs.id"
        :data-testid="`${testId}-input`"
        :name="$attrs.name"
        :disabled="disabled"
        :state="getNameValidationState(validationContext)"
        v-bind="$attrs"
        @input="$emit('input', $event)"
        @blur="$emit('blur', $event)"
      />
    </gl-form-group>
  </validation-provider>
</template>
